webpackJsonp([50556880970279],{

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ContactView = __webpack_require__(5);
	
	var _ContactView2 = _interopRequireDefault(_ContactView);
	
	var _FooterView = __webpack_require__(6);
	
	var _FooterView2 = _interopRequireDefault(_FooterView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MentionsLegales = function MentionsLegales(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Mentions L\xE9gales - Com des L\xE9zards'
	    }),
	    _react2.default.createElement(
	      _View2.default,
	      { colorMode: '2' },
	      _react2.default.createElement(
	        'div',
	        { style: { padding: '20px', fontFamily: 'Bree Serif' } },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Mentions L\xE9gales'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Le site comdeslezards.com est \xE9dit\xE9 pas COM DES LEZARDS, soci\xE9t\xE9 \xE0 responsabilit\xE9 limit\xE9e au capital de 16 000,00 \u20AC, et immatricul\xE9e sous le num\xE9ro RCS Toulon B 438 033 367.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'Si\xE8ge social : 54 avenue des \xEEles d\'or, 83400 Hy\xE8res',
	          _react2.default.createElement('br', null),
	          'Num\xE9ro de TVA intracommunautaire : FR 82 438 033 367',
	          _react2.default.createElement('br', null),
	          'Email : team@comdeslezards.com',
	          _react2.default.createElement('br', null),
	          'T\xE9l\xE9phone : +33 7 66 89 09 21'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Directeur de la publication :'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Benjamin Fille'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'H\xE9bergement du site :'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'AMEN SASU, 12-14, Rond Point des Champs Elys\xE9es 75008 Paris'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Le Service Client est joignable du Lundi au Vendredi de 9h \xE0 19h au 0811 88 77 66 (0,06 \u20AC / min + prix de l\'appel).',
	          _react2.default.createElement('br', null),
	          'Le Service Commercial est joignable du Lundi au Vendredi de 9h \xE0 19h au 0811 88 77 66 (0,06 \u20AC / min + prix de l\'appel).'
	        )
	      ),
	      _react2.default.createElement(_FooterView2.default, null)
	    )
	  );
	};
	
	exports.default = MentionsLegales;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-mentions-legales-jsx-86d162dbfd572cef6bcc.js